import React from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
  Grid,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { MobileDatePicker, MobileDateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  backgroundColor: "white",
  boxShadow: 24,
  p: 4,
};

const statutOptions = ["en attente", "accepté", "rejeté"];

const ModelCheck = ({
  open,
  onClose,
  formData,
  setFormData,
  handleSubmit,
  error,
}) => {
  const { t } = useTranslation();
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2" gutterBottom>
          {formData.id
            ? t("Modifier le Chèque")
            : t("Ajouter un Nouveau Chèque")}
        </Typography>
        {error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            {" "}
            <TextField
              fullWidth
              label={t("Nom")}
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {" "}
            <TextField
              fullWidth
              label={t("Numéro de Chèque")}
              name="numero_cheque"
              value={formData.numero_cheque}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label={t("Banque")}
              name="banque"
              value={formData.banque}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {" "}
            <TextField
              fullWidth
              label={t("Montant")}
              name="montant"
              value={formData.montant}
              onChange={handleChange}
              margin="normal"
              type="number"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel shrink htmlFor="date-emission">
                {t(`Date d'Émission`)}
              </InputLabel>

              <MobileDatePicker
                value={dayjs(formData.date_emission) || null} // null instead of empty string to avoid formatting issues
                onChange={
                  (newValue) => handleDateChange("date_emission", newValue) // handle the Dayjs object directly
                }
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel shrink htmlFor="date-encaissement">
                {t("Date d'Encaissement")}
              </InputLabel>

              <MobileDateTimePicker
                value={dayjs(formData.date_encaissement) || null} // Use null instead of empty string
                onChange={
                  (newValue) => handleDateChange("date_encaissement", newValue) // Directly handle Dayjs object
                }
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            {" "}
            <TextField
              fullWidth
              select
              label={t("Statut")}
              name="statut_cheque"
              value={formData.statut_cheque}
              onChange={handleChange}
              margin="normal"
            >
              {statutOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="contained" color="error" onClick={onClose}>
                  {t("Cancel")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  {formData.id ? t("Update") : t("Create")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModelCheck;
